import React, { RefObject } from "react"
import { useParams } from "react-router-dom"
import { GuestSummary } from "sharedTypes"
import { useCurrentEvent } from "queries/events"
import { useEventGuestPaths } from "utilities/routes"
import SharedGuestList from "components/GuestList/GuestList"
import useGuestSelection from "../../useGuestSelection"
import Item from "../Item"

type Props = {
  guests: GuestSummary[]
  order: string
  filtered: boolean
  allSelected: boolean
  multipleSelectEnabled: boolean
  scrollRef: RefObject<HTMLElement>
}

/** The Guests page's list: a guest opens on click, a checkbox or ⇧-click selects several. */
const GuestList = ({
  guests, order, filtered, allSelected, multipleSelectEnabled, scrollRef,
}: Props) => {
  const { data: event } = useCurrentEvent()
  const { eventId, guestId } = useParams<{ eventId: string, guestId: string }>()
  const { eventGuestPath } = useEventGuestPaths()
  const { selectedGuestIdsSet, handleSelectionChange, handleClick } = useGuestSelection({
    guests, allSelected, event,
  })

  return (
    <SharedGuestList guests={guests} filtered={filtered} scrollRef={scrollRef}>
      {(guest, plusOne) => (
        <Item
          guest={guest}
          order={order}
          path={eventGuestPath(eventId, guest.id)}
          plusOne={plusOne}
          selected={allSelected || selectedGuestIdsSet.has(guest.id)}
          open={guest.id === guestId}
          multipleSelectEnabled={multipleSelectEnabled}
          onClick={handleClick}
          onSelectionChange={handleSelectionChange}
        />
      )}
    </SharedGuestList>
  )
}

export default GuestList
